/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var sizeBtn = document.querySelector('.productForm__LabelLink');
var modalSizeContent = document.querySelector('.modal__Content');
  sizeBtn.addEventListener('click', function() {
    modalSizeContent.classList.remove('hide');
  });
var modalCloseBtn = document.querySelector('.modal-size-close');
 modalCloseBtn.addEventListener('click', function() {
    modalSizeContent.classList.add('hide');
  });

document.addEventListener('DOMContentLoaded', function() {
 
  var tabItems = document.querySelectorAll('ul.tabs li');
  tabItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var tabId = this.getAttribute('data-tab');

      tabItems.forEach(function(item) {
        item.classList.remove('current');
      });
      document.querySelectorAll('.tab-content').forEach(function(content) {
        content.classList.remove('current');
      });

      this.classList.add('current');
      document.getElementById(tabId).classList.add('current');
    });
  });
});
